import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { shareReplay } from "rxjs/operators";
import { PrefixedRequestService } from "src/app/core/prefixed-request.service";
import {
  CapstonePartner,
  CapstoneSite,
} from "src/app/core/sites/capstone-site.model";
import { mapNullable, UUID } from "src/utils";

@Injectable()
export class CapstoneDataService {
  public constructor(private readonly prexiedRequest: PrefixedRequestService) {}

  public getCapstoneSiteList(
    partnerKey: UUID,
  ): Observable<readonly CapstoneSite[] | null> {
    if (!partnerKey.toString().length) {
      return of([]);
    }
    return this.prexiedRequest
      .get({
        prefix: "partner",
        path: "/Sites/enterprise-sites",
      })
      .pipe(
        mapNullable((data) => CapstoneSite.deserializeList(data)),
        shareReplay(1),
      );
  }

  public getCapstonePartnerList(
    searchKey: string,
  ): Observable<readonly CapstonePartner[] | null> {
    if (!searchKey.length) {
      return of([]);
    }
    return this.prexiedRequest
      .get({
        prefix: "global",
        path: "/partners/enterprise-partners",
        queryParams: { searchKey },
      })
      .pipe(
        mapNullable((data) => CapstonePartner.deserializeList(data)),
        shareReplay(1),
      );
  }
}
